import React from 'react';
import styled from 'styled-components';

import { Link } from 'gatsby';

import Section from './global/section';

const FooterStyle = styled.div`
	.flex {
		display: flex;
		& > div {
			padding: 0 1rem;
		}
		.logos {
			flex: 0 0 250px;
			img {
				width: 100%;
				&:first-child {
					margin-bottom: 2rem;
				}
			}
		}
		.numbers {
			flex: 1 1;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			border-left: 2px solid ${(p) => p.theme.color.green};
			margin-left: 1rem;
			padding-left: 2rem;
			h4 {
				font-size: 1.125rem;
				font-weight: 700;
				margin-bottom: 0.5rem;
			}
			a {
				font-size: 1.125rem;
				text-decoration: none;
				display: inline-block;
				color: #fff;
				position: relative;
				&::after {
					content: '';
					background-color: #fff;
					transition: 0.3s opacity;
					width: 100%;
					height: 1px;
					position: absolute;
					bottom: 0;
					right: 0;
					opacity: 0;
				}
				&:hover::after {
					opacity: 1;
				}
			}
		}
		.misc {
			flex: 0 0 250px;
			a {
				font-size: 1.125rem;
				text-decoration: none;
				display: inline-block;
				margin-bottom: 1rem;
				color: #fff;
			}
			ul {
				margin-bottom: 2rem;
				a {
					position: relative;
					&::after {
						content: '';
						background-color: #fff;
						transition: 0.3s width;
						height: 1px;
						position: absolute;
						bottom: 0;
						width: 0;
						left: 0;
					}
					&:hover::after {
						width: 100%;
					}
				}
			}
			img {
				width: 2rem;
				height: 2rem;
				display: inline-block;
				margin-right: 0.5rem;
				opacity: 1;
				transition: 0.3s opacity;

				&:hover {
					opacity: 0.7;
				}
			}
		}

		@media all and (max-width: 868px) {
			flex-wrap: wrap;
			justify-content: center;
			.logos {
				flex: none;
				width: 80%;
				margin: 0 auto;
				text-align: center;
				img {
					display: inline-block;
				}
			}
			.numbers {
				flex: none;
				width: 100%;
				text-align: center;
				margin-left: 0;
				margin-bottom: 2rem;
				padding-left: 1rem;
				margin-top: 4rem;
				padding-top: 4rem;
				border-left: none;
				border-top: 3px solid ${(p) => p.theme.color.green};
				a {
					display: block;
					margin-bottom: 1.5rem;
				}
			}

			.misc {
				flex: none;
				width: 100%;
				text-align: center;
				img {
					width: 3rem;
					height: 3rem;
					margin: 0 0.5rem;
				}
			}
		}
	}
`;

export default () => (
	<FooterStyle>
		<Section bg="dark">
			<div className="flex">
				<div className="logos">
					<Link to="/">
						<img src="/img/StartTalking_Logo.svg" alt="Start Talking logo" />
					</Link>
					<a target="_blank" rel="noopener noreferrer" href="https://cmha.ca/">
						<img src="/img/CMHA-color.svg" alt="CMHA logo" />
					</a>
				</div>
				<div className="numbers">
					<div>
						<h4>Mental Health Crisis Line</h4>
						<a href="tel:+18888938333">1-888-893-8333</a>
					</div>
					<div>
						<h4>Drug & Alcohol Helpline</h4>
						<a href="tel:+18005658603">1-800-565-8603</a>
					</div>
					<div>
						<h4>Ontario Problem Gambling Helpline</h4>
						<a href="tel:+18882303505">1-888-230-3505</a>
					</div>
				</div>
				<div className="misc">
					<ul>
						<li>
							<Link to="/contact/">contact us</Link>
						</li>
						<li>
							<Link to="/privacy/">privacy policy</Link>
						</li>
						<li>
							<Link to="/terms/">terms of use</Link>
						</li>
					</ul>
					<div className="icon-tray">
						<a
							target="_blank"
							rel="noopener noreferrer"
							href="https://www.facebook.com/StartTalking1/"
						>
							<img src="/img/facebook.svg" alt="facebook" />
						</a>
						<a
							target="_blank"
							rel="noopener noreferrer"
							href="https://twitter.com/starttalking1"
						>
							<img src="/img/twitter.svg" alt="twitter" />
						</a>
						<a
							target="_blank"
							rel="noopener noreferrer"
							href="https://www.youtube.com/user/cmhanational"
						>
							<img src="/img/youtube.svg" alt="youtube" />
						</a>
					</div>
				</div>
			</div>
		</Section>
	</FooterStyle>
);
